var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,15h-1v-1c0-5.506-4.07-10.067-9.358-10.864,.224-.323,.358-.714,.358-1.136,0-1.103-.897-2-2-2s-2,.897-2,2c0,.422,.133,.813,.358,1.136C5.07,3.933,1,8.494,1,14v1H0v1H4.348c-1.082,.755-1.892,1.885-2.21,3.254,0,.002-.003,.004-.003,.006l-1.282,4.739H1.888l1.212-4.478c.002-.007,0-.014,.001-.021h.004c.468-2.061,2.272-3.501,4.388-3.501h6.008c.905,0,1.642,.737,1.642,1.643,0,.812-.606,1.511-1.41,1.625l-5.161,.737,.142,.99,5.16-.737c.527-.075,.995-.312,1.372-.647l.012,.013,3.729-3.247c.604-.548,1.611-.475,2.132,.148,.541,.622,.479,1.573-.137,2.12l.002,.002s-.007,.003-.01,.006l-5.759,5.347h1.47l4.962-4.607h0s0,0,0,0l.008-.007s.002-.004,.004-.005c.972-.875,1.091-2.352,.308-3.38h2.035v-1ZM11,2c0-.552,.449-1,1-1s1,.448,1,1-.449,1-1,1-1-.448-1-1ZM2,15v-1c0-5.514,4.486-10,10-10s10,4.486,10,10v1H2Zm14.131,2.537c-.023-.582-.236-1.111-.578-1.537h2.343l-1.765,1.537Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/food.7d2b421fa47c969ef207ac356504ef33.svg";
export { ForwardRef as ReactComponent };